/**
 * Detects when a visitor's already-open tab is running an older published
 * theme version (e.g. right after we publish a new theme) and forces a full
 * reload so they automatically get the latest UI/UX instead of a stale page
 * that happened to already be loaded in memory.
 *
 * How it works:
 * - layout/theme.liquid stamps every page with <meta name="theme-version-id"
 *   content="{{ theme.id }}">.
 * - This script remembers the id the tab loaded with, then periodically
 *   re-fetches the current URL (bypassing cache) and compares the id in the
 *   freshly-fetched HTML against the one this tab is running.
 * - If they differ, a newer theme has been published since this tab loaded,
 *   so we reload the page.
 * - It also re-checks immediately whenever the tab regains focus, and when a
 *   page is restored from the browser's back/forward cache (bfcache), since
 *   those are the two most common ways someone ends up looking at a
 *   long-stale tab.
 */
(function () {
  var versionMeta = document.querySelector('meta[name="theme-version-id"]');
  var CURRENT_VERSION = versionMeta ? versionMeta.content : null;
  if (!CURRENT_VERSION) return;

  var CHECK_INTERVAL_MS = 5 * 60 * 1000; // re-check every 5 minutes while visible
  var MIN_TIME_BETWEEN_CHECKS_MS = 30 * 1000; // avoid re-checking on every rapid tab switch
  var lastCheck = Date.now();

  function isActivelyTyping() {
    var el = document.activeElement;
    if (!el) return false;
    var tag = el.tagName;
    return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable === true;
  }

  function checkForNewVersion() {
    lastCheck = Date.now();

    fetch(location.pathname + location.search, {
      cache: 'no-store',
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var match = html.match(/<meta name="theme-version-id" content="([^"]+)"/);
        var latestVersion = match ? match[1] : null;

        if (latestVersion && latestVersion !== CURRENT_VERSION) {
          if (isActivelyTyping()) {
            // Don't yank the page out from under someone mid-input;
            // this will be re-checked on the next tick/focus event.
            return;
          }
          location.reload();
        }
      })
      .catch(function () {
        // Network hiccups shouldn't cause noisy errors or reload loops.
      });
  }

  setInterval(function () {
    if (document.visibilityState === 'visible') {
      checkForNewVersion();
    }
  }, CHECK_INTERVAL_MS);

  document.addEventListener('visibilitychange', function () {
    if (
      document.visibilityState === 'visible' &&
      Date.now() - lastCheck > MIN_TIME_BETWEEN_CHECKS_MS
    ) {
      checkForNewVersion();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      checkForNewVersion();
    }
  });
})();
